import { z } from "zod";
export const WHATSAPP_CLEAR_CONFIRMATION_PHRASE = "CLEAR WHATSAPP DATA";
export const WHATSAPP_CLEAR_RESYNC_SCHEMA_VERSION = "whatsapp-clear-resync-preflight@1";
export const WhatsAppClearResyncRequestSchema = z.object({
    workspaceId: z.uuid(),
    scopeFingerprint: z.string().regex(/^[0-9a-f]{64}$/u),
    confirmation: z.literal(WHATSAPP_CLEAR_CONFIRMATION_PHRASE)
}).strict();
const CountSchema = z.number().int().nonnegative();
const ReviewedArtifactSchema = z.object({
    key: z.enum([
        "WHATSAPP_MESSAGES",
        "WHATSAPP_CONVERSATIONS",
        "WHATSAPP_DIRECTORY_IDENTITIES",
        "WHATSAPP_SEARCH_ENTRIES",
        "WHATSAPP_CONTEXT_MANIFESTS",
        "WHATSAPP_EVALUATIONS",
        "WHATSAPP_ATTACHMENTS"
    ]),
    label: z.string().min(1).max(120),
    count: CountSchema
}).strict();
const PreservedAuthoritySchema = z.object({
    key: z.enum([
        "AUTH_SESSION_KEYS",
        "WORK_NOTES_DECISIONS",
        "APPROVALS_EFFECTS_RECEIPTS",
        "AUDIT_TRAIL",
        "OUTBOUND_HISTORY",
        "OTHER_WORKSPACES",
        "RENTAL_TENANT",
        "SOURCE_BACKUPS_FILES"
    ]),
    label: z.string().min(1).max(160)
}).strict();
const BlockerSchema = z.object({
    code: z.enum([
        "DEPENDENCY_CONTRACT_INCOMPLETE",
        "RESYNC_COMPLETENESS_UNPROVEN",
        "HUMAN_ACCOUNT_IDENTITY_UNPROVEN",
        "ACCOUNT_DATA_LINEAGE_UNPROVEN",
        "CONNECTION_SCOPE_UNAVAILABLE",
        "PENDING_APPROVALS",
        "IN_FLIGHT_EFFECTS",
        "PENDING_SOURCE_EVALUATIONS"
    ]),
    message: z.string().min(1).max(240)
}).strict();
export const WhatsAppClearResyncPreflightSchema = z.object({
    schemaVersion: z.literal(WHATSAPP_CLEAR_RESYNC_SCHEMA_VERSION),
    available: z.literal(false),
    workspace: z.object({
        id: z.uuid(),
        name: z.string().min(1).max(160),
        slug: z.string().min(2).max(63)
    }).strict(),
    account: z.object({
        label: z.string().min(1).max(80),
        connectionStatus: z.enum([
            "STARTING",
            "CONNECTING",
            "SCAN_REQUIRED",
            "CONNECTED",
            "DISCONNECTED",
            "RECONNECTING",
            "UNAVAILABLE"
        ]),
        connectionUpdatedAt: z.iso.datetime().nullable(),
        monitoringScope: z.literal("ALL_CONVERSATIONS"),
        bindingStatus: z.enum(["SERVER_BOUND", "UNAVAILABLE"]),
        bindingFingerprint: z.string().regex(/^[0-9a-f]{64}$/u).nullable()
    }).strict().superRefine((account, context) => {
        if ((account.bindingStatus === "SERVER_BOUND") !== (account.bindingFingerprint !== null)) {
            context.addIssue({ code: "custom", path: ["bindingFingerprint"], message: "Account binding status and fingerprint must agree." });
        }
    }),
    guards: z.object({
        pendingApprovals: CountSchema,
        inFlightEffects: CountSchema,
        pendingSourceEvaluations: CountSchema
    }).strict(),
    reviewedArtifacts: z.array(ReviewedArtifactSchema).length(7),
    wouldDeleteNow: z.array(z.never()).length(0),
    preservedAuthorities: z.array(PreservedAuthoritySchema).length(8),
    blockers: z.array(BlockerSchema).min(2),
    confirmationPhrase: z.literal(WHATSAPP_CLEAR_CONFIRMATION_PHRASE),
    authDisposition: z.literal("RETAINED"),
    reconnectDisposition: z.literal("SEPARATE_EXPLICIT_ACTION"),
    resyncContract: z.array(z.string().min(1).max(220)).length(5),
    scopeFingerprint: z.string().regex(/^[0-9a-f]{64}$/u),
    generatedAt: z.iso.datetime()
}).strict();
//# sourceMappingURL=whatsapp-clear-resync.js.map